import { flatMap } from 'lodash';
import { ReactNode } from 'react';
/**
 * @name joinWithNode
 *
 * Acts like `Array.join()` but allows joining with JSX nodes.
 *
 * The following example inserts a comma and a line break between each element:
 *
 * ```typescript
 * const remainingEventNames = joinWithNode(
 *   <>
 *     {', '}
 *     <br />
 *   </>,
 *   remainingEvents,
 * );
 * ```
 */
export default function joinWithNode<E extends ReactNode>(
  node: ReactNode,
  elements: E[],
): Array<E | ReactNode> {
  return flatMap(elements, (val: E, index: number) =>
    index === elements.length - 1 ? [val] : [val, node],
  );
}
